import { useTranslation } from "react-i18next";
import { EntityGrid } from "@/components/common/EntityGrid";
import { ListMemberCard } from "./ListMemberCard";
import { ListMember } from "@/types/list";

interface ListMembersGridProps {
  members: ListMember[];
  onMembersChange?: () => void;
  onRemoveMember?: (candidateId: string) => void;
}

export const ListMembersGrid = ({ members, onMembersChange, onRemoveMember }: ListMembersGridProps) => {
  const { t } = useTranslation();

  if (!members || members.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {t("lists.members.empty.title", "No candidates found")}
        </h3>
        <p className="text-gray-600">
          {t("lists.members.empty.description", "Add candidates to this list to get started")}
        </p>
      </div>
    );
  }

  return (
    <EntityGrid
      data={members}
      isLoading={false}
      renderItem={(member) => (
        <ListMemberCard 
          key={member.id} 
          candidate={member.candidate} 
          onRemove={onRemoveMember}
        />
      )}
    />
  );
};
